import type { SVGProps } from 'react';

const SvgBugMarkOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 266 178" {...props}>
    <path fill={props.color} d="M266 178H0V0h266l-55.84 89ZM4 174h254.77l-53.33-85 53.33-85H4Z" />
  </svg>
);

export default SvgBugMarkOutlined;
